module.exports = __webpack_public_path__ + "static/media/RESTAURANT-INFO-ONBOARDING.c547e4cb.pdf";